export default (ngModule) => {
  require("./comparator/welcome-ctrl")(ngModule);
  require("./comparator/root-ctrl")(ngModule);
  require("./comparator/step1-ctrl")(ngModule);
  require("./comparator/step2-ctrl")(ngModule);
  require("./comparator/step3-ctrl")(ngModule);
  require("./comparator/step3-ctrl-ahb")(ngModule);
  require("./comparator/step3-ctrl-ahm")(ngModule);
  require("./comparator/step3-ctrl-auf")(ngModule);
  require("./comparator/step3-ctrl-hambs")(ngModule);
  require("./comparator/step3-ctrl-hci")(ngModule);
  require("./comparator/step3-ctrl-hbf")(ngModule);
  require("./comparator/step3-ctrl-hcf")(ngModule);
  require("./comparator/step3-ctrl-nib")(ngModule);
  require("./comparator/step3-ctrl-nhb")(ngModule);
  require("./comparator/step3-ctrl-nogateway")(ngModule);
  require("./comparator/step3-ctrl-sps")(ngModule);
  require("./comparator/step3-ctrl-hif")(ngModule);
  require("./comparator/step3-ctrl-rte")(ngModule);
  require("./comparator/step4-ctrl")(ngModule);
  require("./comparator/retention-ctrl")(ngModule);
  require("./comparator/operator-step1-ctrl")(ngModule);
  require("./comparator/operator-step2-ctrl")(ngModule);
  require("./comparator/retrieve-password-ctrl")(ngModule);
  require("./comparator/zoho-ctrl")(ngModule);
  require("./comparator/quote-ctrl")(ngModule);
  require("./comparator/price-summary-ctrl")(ngModule);
};



// WEBPACK FOOTER //
// ./src/controllers/index.js